import { all, call, put, take } from 'redux-saga/effects';
import { get } from 'lodash';
import { notification } from 'antd';

import { LOAD_LIST_PATIENT_KIN } from '../type';
import {
  loadListPatientKinErrorAction,
  loadListPatientKinSuccessAction,
} from '../action';

import MessengerResource from 'common/resource/MessengerResource';

import { accountService } from 'services';

function* loadListPatientKin() {
  while (1) {
    const action = yield take(LOAD_LIST_PATIENT_KIN);
    try {
      const callback = get(action, 'payload.callback');
      const response = yield call(
        accountService.getListPatientKin,
        action.payload,
      );
      callback && callback(response);

      yield put(loadListPatientKinSuccessAction(response));
    } catch (error) {
      notification.error({
        message: MessengerResource.account.loadListPatientKinFail,
        description: error.message,
      });
      yield put(loadListPatientKinErrorAction(error));
    }
  }
}

export default function* rootSaga() {
  yield all([loadListPatientKin()]);
}
